// Define constants for different elements
const mobileMenuToggle        = document.querySelector( '#mobile-menu-toggle' );
const mobileMenu              = document.querySelector( '#menu-mobile' );
const mobileMenuTopLevelItems = document.querySelectorAll( '#menu-mobile .menu-link-top' );

// Listen for a click on the menu toggle
mobileMenuToggle.addEventListener( 'click', function ( event ) {

	// If the aria-expanded attribute is false
	if ( mobileMenuToggle.getAttribute( 'aria-expanded' ) === 'false' ) {

		// Track the click
		ofhMixpanelTrack( 'Navigation Menu Clicked' );

		// Open the menu
		mobileMenu.classList.add( 'is-active' );

		// Update the aria-expanded attribute on the toggle
		mobileMenuToggle.setAttribute( 'aria-expanded', 'true' );

		// Update the aria-label attribute on the toggle
		mobileMenuToggle.setAttribute( 'aria-label', 'Close the menu' );

	// Otherwise the aria-expanded attribute is true
	} else {
		// Close the menu
		mobileMenu.classList.remove( 'is-active' );

		// Update the aria-expanded attribute on the toggle
		mobileMenuToggle.setAttribute( 'aria-expanded', 'false' );

		// Update the aria-label attribute on the toggle
		mobileMenuToggle.setAttribute( 'aria-label', 'Open the menu' );
	}

	// Blur if it's a mouse / touch event
	if ( event.clientX > 0 ) {
		event.target.blur();
	}
} );

// Listen for an escape key being pressed
document.addEventListener( 'keydown', function ( event ) {
	if ( event.key === 'Escape' ) {
		// Close the menu
		mobileMenu.classList.remove( 'is-active' );

		// Update the aria-expanded attribute on the toggle
		mobileMenuToggle.setAttribute( 'aria-expanded', 'false' );

		// Blur the toggle
		mobileMenuToggle.blur();
	}
} );

// Loop through the top-level menu items
mobileMenuTopLevelItems.forEach( function ( menuItem ) {

	// Get top level menu section
	let navigation_menu_section = menuItem.innerText;

	// Add a click event listener
	menuItem.addEventListener( 'click', function ( event ) {

		// Stop the link being followed
		event.preventDefault();

		// Stop propagation up to the body tag
		event.stopPropagation();

    // Get the destination url of the clicked link
    let link_destination_url = menuItem.getAttribute( 'href' );

    // Join Button Clicked
    if (
      menuItem.innerText.toLowerCase().startsWith( 'join' ) ||
      menuItem.innerText.toLowerCase().startsWith( 'ymuno' )
    ) {

      let button_name = menuItem.innerText;

			// Track the join click
      ofhMixpanelTrack(
        'Join Button Clicked',
        {
          'button_name': button_name,
          'link_source_url': window.location.href,
          'referrer_site_domain_name': 'public',
          'destination_site_domain_name': 'study'
        }
      );

			// Track the cross-domain navigation
      ofhMixpanelTrack(
        'Cross-domain Navigation',
        {
          'referrer_site_domain_name': 'public',
          'destination_site_domain_name': 'study'
        }
      );

			// Wait for 100ms before following the link so the tracking has time to take effect
			setTimeout(
				function() {
					window.location.href = link_destination_url;
				},
				100
			);
    }

    // User Sign In Clicked
    else if ( menuItem.innerText.toLowerCase().startsWith( 'registered' ) ) {

			// Track the sign-in
      ofhMixpanelTrack( 'User Sign In Clicked' );

			// Track the cross-domain navigation
      ofhMixpanelTrack(
        'Cross-domain Navigation',
        {
          'referrer_site_domain_name': 'public',
          'destination_site_domain_name': 'study'
        }
      );

			// Wait for 100ms before following the link so the tracking has time to take effect
			setTimeout(
				function() {
					window.location.href = link_destination_url;
				},
				100
			);
    }

		// If this is opening a menu
		if ( event.target.getAttribute( 'aria-expanded' ) === 'false' ) {
			// Make aria-expanded true on clicked menu item
			event.target.setAttribute( 'aria-expanded', 'true' );

			// Add class to list item for highlighting
			event.target.parentNode.classList.add( 'is-active' );

			// Track the navigation menu click
			ofhMixpanelTrack(
				'Navigation Menu Clicked',
				{
					'navigation_menu_section': navigation_menu_section
				}
			);

			// Otherwise this menu needs to close
		} else {
			// Make aria-expanded false on clicked menu item
			event.target.setAttribute( 'aria-expanded', 'false' );

			// Remove class frome list item for highlighting
			event.target.parentNode.classList.remove( 'is-active' );
		}
	} );
} );
